import script from "./AssetableTable.vue?vue&type=script&lang=js"
export * from "./AssetableTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/assets/AssetableTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dedfaf92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dedfaf92', __exports__)) {
    console.log('reload')
    api.reload('dedfaf92', __exports__)
  }
  
}


export default __exports__